import { useQuery } from 'react-query'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert } from '../../../utils/alert'

type Item = {
  cod: number
  nome_cientifico: string
  tipo_microrganismo: number
  tipo_microrganismo_nome: string
}

interface Microrganismos {
  itens: Item[]
  total: number
}

export const useGetMicrorganismos = (pagination = 15, page = 1, nome?: string) => {
  const queryKey: any = [`recomendacao/microrganismo`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<
    Microrganismos,
    Error
  >(
    queryKey,
    async () => {
      const paramNome = nome ? `&nome=${nome}` : ''
      return api
        .get(
          `recomendacao/microrganismo?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente
          }&pagination=${pagination}&page=${page}${paramNome}`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de cargos!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_mircrorganismos: data,
    carregando_mircrorganismos: isFetching,
    refetch_data_mircrorganismos: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}
